import React, { useContext } from 'react';
import { Link } from 'gatsby';

import { useImage } from '@hooks/useImage';
import ResponsiveResolutionImage from '@components/responsive-resolution-image/responsive-resolution-image';
import { GlobalContext } from '@store/global-state';
import { SIDEBAR_VIEWS } from '@vitl-services/constants/blog';
import * as styles from './sidebar-banner.module.scss';

const SidebarBanner = () => {
  const { setSidebar } = useContext(GlobalContext);
  const bannerImage = useImage(['banners/hamburger-menu-shop.jpg']);

  return (
    <div className={styles.sideBanner}>
      <Link
        to={`${process.env.GATSBY_VITL_HOST_NAME}/consultation`}
        onClick={() => setSidebar(SIDEBAR_VIEWS.empty)}
      >
        <ResponsiveResolutionImage
          url={bannerImage}
          title={'banner image'}
          width={260}
          height={140}
        />
      </Link>
    </div>
  );
};

export default SidebarBanner;
